import _ from 'lodash'

export function cleanPrintTo (display, menuBlob) {
  const availablePrinters = _.get(menuBlob, 'printers', []).map(it => it.id)
  display.printTo = _.get(display, 'printTo', []).filter(it => availablePrinters.includes(it))
}
